 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTFM_00_OPENINGPAGE_IMAGE from '@/components/Text/FM_00_OpeningPage_image'
 import LOVE_1 from '@/components/love_1'
 import TEXTFM_04_MAINTOC_EPUB_TEXT from '@/components/Text/FM_04_MainTOC_ePub_text'
 import TEXTFM_05_ALLABOUTICEPOPS_TEXT from '@/components/Text/FM_05_AllAboutIcePops_text'
 import TEXTFM_06_ALLABOUTICEPOPS_IMAGE from '@/components/Text/FM_06_AllAboutIcePops_image'
 import TEXTFM_08_TYPESOFPOPS_TEXT from '@/components/Text/FM_08_TypesOfPops_text'
 import TEXTFM_09_INGREDIENTS_TEXT from '@/components/Text/FM_09_Ingredients_text'
 import TEXTFM_10_INGREDIENTS_IMAGE from '@/components/Text/FM_10_Ingredients_image'
 import TEXTFM_12_TOOLS_TEXT from '@/components/Text/FM_12_Tools_text'
 import TEXTFM_13_UNMOLDINGICEPOPS_TEXT from '@/components/Text/FM_13_UnmoldingIcePops_text'
 import TEXTFM_14_UNMOLDINGICEPOPS_IMAGE from '@/components/Text/FM_14_UnmoldingIcePops_image'
 import TEXTFM_16_SERVINGICEPOPS_TEXT from '@/components/Text/FM_16_ServingIcePops_text'
 import TEXTCH01_00_TOC_EPUB_IMAGE from '@/components/Text/CH01_00_TOC_ePub_image'
 import TEXTCH01_01_TOC_EPUB_TEXT from '@/components/Text/CH01_01_TOC_ePub_text'
 import TEXTCH01_02_CANTALOUPE_EPUB_IMAGE from '@/components/Text/CH01_02_Cantaloupe_ePub_image'
 import TEXTCH01_03_CANTALOUPE_EPUB_TEXT from '@/components/Text/CH01_03_Cantaloupe_ePub_text'
 import TEXTCH01_04_SOURPLUM_EPUB_IMAGE from '@/components/Text/CH01_04_SourPlum_ePub_image'
 import TEXTCH01_05_SOURPLUM_EPUB_TEXT from '@/components/Text/CH01_05_SourPlum_ePub_text'
 import TEXTCH01_06_FRESHPEACH_EPUB_TEXT from '@/components/Text/CH01_06_FreshPeach_ePub_text'
 import TEXTCH01_07_PINEAPPLE_EPUB_TEXT from '@/components/Text/CH01_07_Pineapple_ePub_text'
 import TEXTCH01_08_BLUEBERRYVERBENA_EPUB_IMAGE from '@/components/Text/CH01_08_BlueberryVerbena_ePub_image'
 import TEXTCH01_09_BLUEBERRYVERBENA_EPUB_TEXT from '@/components/Text/CH01_09_BlueberryVerbena_ePub_text'
 import TEXTCH01_10_TAGERINEBERGAMOT_EPUB_IMAGE from '@/components/Text/CH01_10_TagerineBergamot_ePub_image'
 import TEXTCH01_11_TAGERINEBERGAMOT_EPUB_TEXT from '@/components/Text/CH01_11_TagerineBergamot_ePub_text'
 import TEXTCH01_12_RASPBERRYMINT_EPUB_TEXT from '@/components/Text/CH01_12_RaspberryMint_ePub_text'
 import TEXTCH01_13_LEMONBUTTERMILK_EPUB_TEXT from '@/components/Text/CH01_13_LemonButtermilk_ePub_text'
 import TEXTCH01_14_MANGOGINGER_EPUB_IMAGE from '@/components/Text/CH01_14_MangoGinger_ePub_image'
 import TEXTCH01_15_MANGOGINGER_EPUB_TEXT from '@/components/Text/CH01_15_MangoGinger_ePub_text'
 import TEXTCH01_16_PINKLEMONAIDE_EPUB_IMAGE from '@/components/Text/CH01_16_PinkLemonaide_ePub_image'
 import TEXTCH01_17_PINKLEMONAIDE_EPUB_TEXT from '@/components/Text/CH01_17_PinkLemonaide_ePub_text'
 import TEXTCH01_18_BLOODORANGE_EPUB_IMAGE from '@/components/Text/CH01_18_BloodOrange_ePub_image'
 import TEXTCH01_19_BLOODORANGE_EPUB_TEXT from '@/components/Text/CH01_19_BloodOrange_ePub_text'
 import TEXTCH01_20_WATERMELLONLIME_EPUB_IMAGE from '@/components/Text/CH01_20_WatermellonLime_ePub_image'
 import TEXTCH01_21_WATERMELLONLIME_EPUB_TEXT from '@/components/Text/CH01_21_WatermellonLime_ePub_text'
 import TEXTCH01_22_RHUBARB_EPUB_IMAGE from '@/components/Text/CH01_22_Rhubarb_ePub_image'
 import TEXTCH01_23_RHUBARB_EPUB_TEXT from '@/components/Text/CH01_23_Rhubarb_ePub_text'
 import TEXTCH02_00_TOC_EPUB_IMAGE from '@/components/Text/CH02_00_TOC_ePub_image'
 import TEXTCH02_01_TOC_EPUB_TEXT from '@/components/Text/CH02_01_TOC_ePub_text'
 import TEXTCH02_02_CLASSICFUDGE_EPUB_IMAGE from '@/components/Text/CH02_02_ClassicFudge_ePub_image'
 import TEXTCH02_03_CLASSICFUDGE_EPUB_TEXT from '@/components/Text/CH02_03_ClassicFudge_ePub_text'
 import TEXTCH02_04_CHOCOLATEVANILLASWIRL_EPUB_IMAGE from '@/components/Text/CH02_04_ChocolateVanillaSwirl_ePub_image'
 import TEXTCH02_05_CHOCOLATEVANILLASWIRL_EPUB_TEXT from '@/components/Text/CH02_05_ChocolateVanillaSwirl_ePub_text'
 import TEXTCH02_06_DOUBLECHOCOLATESWIRL_EPUB_TEXT from '@/components/Text/CH02_06_DoubleChocolateSwirl_ePub_text'
 import TEXTCH02_07_CHOCOLATETRUFFLECHUNK_EPUB_TEXT from '@/components/Text/CH02_07_ChocolateTruffleChunk_ePub_text'
 import TEXTCH02_08_RASPBERRYCHOCOLATE_EPUB_IMAGE from '@/components/Text/CH02_08_RaspberryChocolate_ePub_image'
 import TEXTCH02_09_RASPBERRYCHOCOLATE_EPUB_TEXT from '@/components/Text/CH02_09_RaspberryChocolate_ePub_text'
 import TEXTCH02_10_MEXICANCHOCOLATE_EPUB_TEXT from '@/components/Text/CH02_10_MexicanChocolate_ePub_text'
 import TEXTCH02_11_MILKCHOCOLATEBANANA_EPUB_TEXT from '@/components/Text/CH02_11_MilkChocolateBanana_ePub_text'
 import TEXTCH03_00_TOC_EPUB_IMAGE from '@/components/Text/CH03_00_TOC_ePub_image'
 import TEXTCH03_01_TOC_EPUB_TEXT from '@/components/Text/CH03_01_TOC_ePub_text'
 import TEXTCH03_02_ORANGECREAM_EPUB_IMAGE from '@/components/Text/CH03_02_OrangeCream_ePub_image'
 import TEXTCH03_03_ORANGECREAM_EPUB_TEXT from '@/components/Text/CH03_03_OrangeCream_ePub_text'
 import TEXTCH03_04_CHEESECAKE_EPUB_IMAGE from '@/components/Text/CH03_04_Cheesecake_ePub_image'
 import TEXTCH03_05_CHEESECAKE_EPUB_TEXT from '@/components/Text/CH03_05_Cheesecake_ePub_text'
 import TEXTCH03_06_ROOTBEERCREAM_EPUB_IMAGE from '@/components/Text/CH03_06_RootBeerCream_ePub_image'
 import TEXTCH03_07_ROOTBEERCREAM_EPUB_TEXT from '@/components/Text/CH03_07_RootBeerCream_ePub_text'
 import TEXTCH03_08_MEYERLEMONCREAM_EPUB_TEXT from '@/components/Text/CH03_08_MeyerLemonCream_ePub_text'
 import TEXTCH03_09_PEACHESCREAM_EPUB_TEXT from '@/components/Text/CH03_09_PeachesCream_ePub_text'
 import TEXTCH03_10_STRAWBERRYVANILLASWIRL_EPUB_IMAGE from '@/components/Text/CH03_10_StrawberryVanillaSwirl_ePub_image'
 import TEXTCH03_11_STRAWBERRYVANILLASWIRL_EPUB_TEXT from '@/components/Text/CH03_11_StrawberryVanillaSwirl_ePub_text'
 import TEXTCH03_12_COCONUTCINNAMON_EPUB_TEXT from '@/components/Text/CH03_12_CoconutCinnamon_ePub_text'
 import TEXTCH03_13_CHERRYHONEYYOGURTSWIRL_EPUB_TEXT from '@/components/Text/CH03_13_CherryHoneyYogurtSwirl_ePub_text'
 import TEXTCH03_14_CARAMELALMOND_EPUB_IMAGE from '@/components/Text/CH03_14_CaramelAlmond_ePub_image'
 import TEXTCH03_15_CARAMELALMOND_EPUB_TEXT from '@/components/Text/CH03_15_CaramelAlmond_ePub_text'
 import TEXTCH03_16_VANILLATOFFEECHIP_EPUB_TEXT from '@/components/Text/CH03_16_VanillaToffeeChip_ePub_text'
 import TEXTCH03_17_COOKIESCREAM_EPUB_TEXT from '@/components/Text/CH03_17_CookiesCream_ePub_text'
 import TEXTCH04_00_TOC_EPUB_IMAGE from '@/components/Text/CH04_00_TOC_ePub_image'
 import TEXTCH04_01_TOC_EPUB_TEXT from '@/components/Text/CH04_01_TOC_ePub_text'
 import TEXTCH04_02_CAPPUCCINO_EPUB_IMAGE from '@/components/Text/CH04_02_Cappuccino_ePub_image'
 import TEXTCH04_03_CAPPUCCINO_EPUB_TEXT from '@/components/Text/CH04_03_Cappuccino_ePub_text'
 import TEXTCH04_04_GREENTEAPOMEGRANATE_EPUB_IMAGE from '@/components/Text/CH04_04_GreenTeaPomegranate_ePub_image'
 import TEXTCH04_05_GREENTEAPOMEGRANATE_EPUB_TEXT from '@/components/Text/CH04_05_GreenTeaPomegranate_ePub_text'
 import TEXTCH04_06_ORANGEBLACKBERRYSANGRIA_EPUB_IMAGE from '@/components/Text/CH04_06_OrangeBlackberrySangria_ePub_image'
 import TEXTCH04_07_ORANGEBLACKBERRYSANGRIA_EPUB_TEXT from '@/components/Text/CH04_07_OrangeBlackberrySangria_ePub_text'
 import TEXTCH04_08_APPLECIDER_EPUB_TEXT from '@/components/Text/CH04_08_AppleCider_ePub_text'
 import TEXTCH04_09_MIMOSA_EPUB_TEXT from '@/components/Text/CH04_09_Mimosa_ePub_text'
 import TEXTCH04_10_CUCUMBERLIMEMINT_EPUB_IMAGE from '@/components/Text/CH04_10_CucumberLimeMint_ePub_image'
 import TEXTCH04_11_CUCUMBERLIMEMINT_EPUB_TEXT from '@/components/Text/CH04_11_CucumberLimeMint_ePub_text'
 import TEXTCH04_12_LAVENDERHUCKLEBERRY_EPUB_IMAGE from '@/components/Text/CH04_12_LavenderHuckleberry_ePub_image'
 import TEXTCH04_13_LAVENDERHUCKLEBERRY_EPUB_TEXT from '@/components/Text/CH04_13_LavenderHuckleberry_ePub_text'
 import TEXTCH04_14_CHAITEA_EPUB_IMAGE from '@/components/Text/CH04_14_ChaiTea_ePub_image'
 import TEXTCH04_15_CHAITEA_EPUB_TEXT from '@/components/Text/CH04_15_ChaiTea_ePub_text'
 import TEXTCH04_16_STRAWBERRYBASIL_EPUB_IMAGE from '@/components/Text/CH04_16_StrawberryBasil_ePub_image'
 import TEXTCH04_17_STRAWBERRYBASIL_EPUB_TEXT from '@/components/Text/CH04_17_StrawberryBasil_ePub_text'
 import LOVE_2 from '@/components/love_2'
 import TEXTBM_00_CREATIVESHAPES_TEXT from '@/components/Text/BM_00_CreativeShapes_text'
 import TEXTBM_02_IMPRINT_IMAGE from '@/components/Text/BM_02_Imprint_image'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/FM_00_OpeningPage_image",
 			"name" : "Text/FM_00_OpeningPage_image",
 			"component" : TEXTFM_00_OPENINGPAGE_IMAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/FM_04_MainTOC_ePub_text",
 			"name" : "Text/FM_04_MainTOC_ePub_text",
 			"component" : TEXTFM_04_MAINTOC_EPUB_TEXT
 		},
 		{
 			"path" : "/Text/FM_05_AllAboutIcePops_text",
 			"name" : "Text/FM_05_AllAboutIcePops_text",
 			"component" : TEXTFM_05_ALLABOUTICEPOPS_TEXT
 		},
 		{
 			"path" : "/Text/FM_06_AllAboutIcePops_image",
 			"name" : "Text/FM_06_AllAboutIcePops_image",
 			"component" : TEXTFM_06_ALLABOUTICEPOPS_IMAGE
 		},
 		{
 			"path" : "/Text/FM_08_TypesOfPops_text",
 			"name" : "Text/FM_08_TypesOfPops_text",
 			"component" : TEXTFM_08_TYPESOFPOPS_TEXT
 		},
 		{
 			"path" : "/Text/FM_09_Ingredients_text",
 			"name" : "Text/FM_09_Ingredients_text",
 			"component" : TEXTFM_09_INGREDIENTS_TEXT
 		},
 		{
 			"path" : "/Text/FM_10_Ingredients_image",
 			"name" : "Text/FM_10_Ingredients_image",
 			"component" : TEXTFM_10_INGREDIENTS_IMAGE
 		},
 		{
 			"path" : "/Text/FM_12_Tools_text",
 			"name" : "Text/FM_12_Tools_text",
 			"component" : TEXTFM_12_TOOLS_TEXT
 		},
 		{
 			"path" : "/Text/FM_13_UnmoldingIcePops_text",
 			"name" : "Text/FM_13_UnmoldingIcePops_text",
 			"component" : TEXTFM_13_UNMOLDINGICEPOPS_TEXT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js